// removed by extract-text-webpack-plugin
module.exports = {"linear":"cubic-bezier(0, 0, 1, 1)","standard":"cubic-bezier(0.4, 0, 0.2, 1)","acelerate":"cubic-bezier(0.8, 0, 0.9, 1)","decelerate":"cubic-bezier(0.1, 0, 0.2, 1)"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/styles/_easings.css
// module id = 779
// module chunks = 0